import axios from 'axios'
import config from '@/config'
const webApi = config[process.env.NODE_ENV].nextbestApi
export default {
    async saveLog(params) {
        try {
            console.log(params)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/log/createlogByCam`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async registerMember(params) {
        try {
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/user/createUserFromCampaign`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },

    async findById(id) {
        try {
            console.log(id)
            let rs = await axios({
                method: 'get',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/user/findByLineId/${id}`,
                responseType: 'json'
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },

    async findOtp(id) {
        try {
            console.log(id)
            let rs = await axios({
                method: 'get',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/otp/findOtp/${id}`,
                responseType: 'json'
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async createOtp(id) {
        try {
            console.log(id)
            let rs = await axios({
                method: 'get',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/otp/createOtp/${id}`,
                responseType: 'json'
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },

    async updateOtp(params) {
        try {
            // console.log(id)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/otp/updateOtp`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.status
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async createRelation(params) {
        try {
            // console.log(id)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/relationship/createRelation`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.status
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async shareSuccess(params) {
        try {
            // console.log(id)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/relationship/shareSuccess`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async getShareNum(params) {
        try {
            // console.log(id)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/relationship/getShareNum`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async getYourFriend(params) {
        try {
            // console.log(id)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Indhbm5hcGFuZWUiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImE3MjdjZjU0LWYwZTYtNDNjOS05MDQ2LTc5ZWQ1MjIzN2Y3OSIsImNsaWVudENvZGUiOiJhb21kYXRhd2l0Y2giLCJpYXQiOjE2MjMzMzQwOTQsImV4cCI6MTcxODAwNjg5NH0.CP3W_dUKA0xShfPaPgPEt0S50OX2u6E5sK8sIiJMTyw` },
                url: `${webApi}/relationship/getYourFriend`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async saveLogCustom(params) {
        try {
            // console.log(params)
            let rs = await axios({
                method: 'post',
                // headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InNpenpsZXIiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImFhOWRjODc3LWU3ODEtNGM2MC1iYjRkLTUzYjVhNzFjMTM1MyIsImNsaWVudENvZGUiOiJzaXp6bGVyIiwiaWF0IjoxNjE0OTM3NTE2LCJleHAiOjE2NDY0OTUxMTZ9.tiM7mFynpzm3xTjRWBkoJvpO0P5f3_DpTXqGKQg0zfk` },
                url: `https://01emepd7xf.execute-api.ap-southeast-1.amazonaws.com/webhook/webhook/custom/aomdatawitch`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    }

}